/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

class VeeroEyeFit extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let _self = this;

    _self.querySelector('button#launch-pd').addEventListener('click', () => {
      let VENDOR_ID = _self.dataset.vendor_id;
      let PDONLY_CONTEXT = _self.dataset.pdonly_context == 'true';
      let eyeSizeCallback = (results) => {
        // (Optional) Implement your custom callback function here
      };
      let eyeSizeExitCallback = () => {};

      EyeSize.launch(eyeSizeCallback, eyeSizeExitCallback, VENDOR_ID, PDONLY_CONTEXT);
    });
  }
}

customElements.define('veero-eye-fit', VeeroEyeFit);
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
